import React from 'react'
import classNames from 'classnames'
import { Button, Icon, SectionCollapse, Text, Title } from 'components'
import { howItWorksSteps, faqItems } from '../data'
import styles from '../ProposalWizard.module.scss'

const IntroScreen = ({
  faqOpenIndex,
  onToggleFaq,
  onCloseIntro,
  onGoToForm,
}) => (
  <>
    <header className={classNames(styles.header, styles.introHeader)}>
      <span className={styles.tag}>Como funciona</span>
      <Title type="h1" fontSize="xlarge">
        Faça Sua Proposta em 5 passos
      </Title>
      <Text fontSize="medium" color="lightBlueColor">
        Negocie o imóvel em condições diferentes das ofertadas na plataforma.
        Veja como é simples:
      </Text>
    </header>
    <main className={styles.main}>
      <ol className={styles.stepsList}>
        {howItWorksSteps.map((step, index) => (
          <li key={step.title} className={styles.stepCard}>
            <div className={styles.stepHeader}>
              {step.icon ? (
                <Icon
                  type={step.icon}
                  color="primaryColor"
                  size={20}
                  className={styles.stepIcon}
                />
              ) : (
                <span className={styles.iconPlaceholder} />
              )}
              <span className={styles.stepLabel}>Passo {index + 1}</span>
            </div>
            <div className={styles.stepBody}>
              <p className={styles.stepTitle}>{step.title}</p>
              <Text fontSize="small" color="lightBlueColor">
                {step.description}
              </Text>
            </div>
          </li>
        ))}
      </ol>
      <div className={styles.importantBox}>
        <Text fontSize="small" color="lightBlueColor">
          <strong>Importante:</strong> enviar uma proposta ou realizar a caução
          não significa que ela foi aceita e não garante a aquisição ou reserva
          do imóvel.
        </Text>
      </div>
      <div className={styles.faq}>
        <Title type="h2" fontSize="large">
          Dúvidas frequentes
        </Title>
        {faqItems.map((item, index) => (
          <SectionCollapse
            key={item.question}
            title={`${index + 1}. ${item.question}`}
            toggle={faqOpenIndex === index}
            onClick={() => onToggleFaq(index)}
          >
            <Text fontSize="small" color="lightBlueColor">
              {item.answer}
            </Text>
          </SectionCollapse>
        ))}
        <div className={styles.trustBox}>
          <Icon type="shield" color="secondColor" size={20} />
          <Text fontSize="small" color="lightBlueColor">
            Todo o fluxo de recebimento, controle e eventual devolução da caução
            fica sob responsabilidade da Resale Tecnologia e Serviços Ltda.,
            inscrita no CNPJ 21.129.873/0001-79.
          </Text>
        </div>
      </div>
    </main>
    <footer className={styles.footer}>
      <Button
        type="outline"
        className={styles.outlineButton}
        onClick={onCloseIntro}
        id="agora_nao"
      >
        Agora não
      </Button>
      <Button onClick={onGoToForm} id="quero_fazer_proposta">
        Quero fazer uma proposta
      </Button>
    </footer>
  </>
)

export default React.memo(IntroScreen)
